/*
 * @Author: Teemo Ding
 * @Date: 2022-02-09 15:21:57
 * @LastEditTime: 2022-06-30 11:39:37
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/AdditionalPromoCode/index.tsx
 */
import { Button, Input } from '@/src/components/Antd';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';
import {
  additionalPromoCode,
  deleteAdditionalPromoCode,
} from 'src/request/order';
import { modal } from 'src/utils/Modal';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const permissions = () => {
  const canAdd = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderAdditionalPromoCode,
        operation: EnumOperation.add,
      }),
    ],
  });
  const canRemove = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderAdditionalPromoCode,
        operation: EnumOperation.remove,
      }),
    ],
  });
  return {
    canAdd,
    canRemove,
  };
};

const AdditionalPromoCode = ({
  orderUuid,
  onUpdate,
  disabled,
  additionalPromotionCodes,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { canAdd, canRemove } = permissions();
  const [form] = Form.useForm();

  const { run: _additionalPromoCode } = useRequest(
    (value) => additionalPromoCode(orderUuid, value),
    {
      manual: true,
      onSuccess: (res) => {
        if (onUpdate) onUpdate(res);
      },
    },
  );
  const { run: _deleteAdditionalPromoCode } = useRequest(
    (value) => deleteAdditionalPromoCode(orderUuid, value),
    {
      manual: true,
      onSuccess: (res) => {
        if (onUpdate) onUpdate(res);
      },
    },
  );

  const onFinish = (values) => {
    form.setFieldsValue({ promoCode: '' });
    _additionalPromoCode(values.promoCode);
  };

  const handleDelete = (value) => {
    modal.error({
      title: getI18n(
        'allOrders.orderDetail.additionalPromoCode_handleDelete_title',
      ),
      content: getI18n(
        'allOrders.orderDetail.additionalPromoCode_handleDelete_content',
      ),
      onCancel: () => void 0,
      onCancelText: getI18n(
        'allOrders.orderDetail.additionalPromoCode_handleDelete_onCancelText',
      ),
      onOk: () => {
        _deleteAdditionalPromoCode(value);
      },
      okText: getI18n(
        'allOrders.orderDetail.additionalPromoCode_handleDelete_onText',
      ),
    });
  };

  const inputOnChange = (value) => {
    form.setFieldsValue({ promoCode: value.toUpperCase() });
  };

  return (
    <SectionWrapper
      title={getI18n(
        'allOrders.orderDetail.additionalPromoCode_return_SetionWrapper',
      )}
      subtitle={getI18n(
        'allOrders.orderDetail.additionalPromoCode_return_subtitle',
      )}>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          name='promoCode'
          rules={[
            {
              required: true,
              message: getI18n(
                'allOrders.orderDetail.additionalPromoCode_return_formItem_message',
              ),
            },
          ]}>
          <Input
            size='large'
            disabled={!canAdd}
            onChange={inputOnChange}
            placeholder={getI18n(
              'allOrders.orderDetail.additionalPromoCode_return_input_placeholder',
            )}
          />
        </Form.Item>
      </Form>

      <Button
        type='primary'
        disabled={!canAdd}
        className={css.applyButton}
        onClick={() => form.submit()}>
        {getI18n('allOrders.orderDetail.additionalPromoCode_return_Button')}
      </Button>
      {(additionalPromotionCodes || []).map((item) => (
        <div key={get(item, 'discountUuid')} className={css.promoCodeList}>
          <div className={css.promoCodeLeft}>
            <div className={css.promoCodeTitle}>
              {getI18n(
                'allOrders.orderDetail.additionalPromoCode_return_prmocodevalid',
              )}
              <span className={css.promoCodeSpan}>
                {get(item, 'promoCode', '')}
              </span>
            </div>

            <div className={css.promoCodeName}>
              {get(item, 'discountName', '')}
            </div>
          </div>
          {canRemove && (
            <Icon
              type='icondelete'
              className={css.icon}
              onClick={() => handleDelete(item.promoCode)}
            />
          )}
        </div>
      ))}
    </SectionWrapper>
  );
};

export default AdditionalPromoCode;
